var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"play_page"},[_c('iframe',{staticClass:"serve_iframe",attrs:{"width":"100%","height":"100vh","src":_vm.src}})])}
var staticRenderFns = []

export { render, staticRenderFns }